import React from 'react';
import { Col } from 'react-bootstrap';

const Logo = ({ scheme }) => {
  if (!scheme) {
    return null;
  }
  return (
    <Col sm={4} className="scheme-logo pull-left">
      <img
        alt={'logo'}
        className="img-responsive img-adjustment"
        src={scheme.attributes.logo}
      />
    </Col>
  );
};

export default Logo;
